module.exports = __webpack_public_path__ + "static/orange-8b2e32dd1fd5b2f77a28626ec2dba0d2.png";